import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaEllipsisV } from 'react-icons/fa';

const MobileHeader = ({ title, showBack = true, actions = null }) => {
  const navigate = useNavigate();

  return (
    <div className="page-header">
      <div className="flex items-center gap-4">
        {showBack && (
          <button
            onClick={() => navigate(-1)}
            className="no-style p-2 -ml-2 text-cigar-cream/80 hover:text-cigar-cream"
            aria-label="Go back"
          >
            <FaArrowLeft size={20} />
          </button>
        )}
        <h1 className="text-xl font-semibold">{title}</h1>
      </div>
      
      {actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
      {!actions && (
        <button 
          className="no-style p-2 -mr-2 text-cigar-cream/80 hover:text-cigar-cream"
          aria-label="More options"
        >
          <FaEllipsisV />
        </button>
      )}
    </div>
  );
};

export default MobileHeader;